import { APP_ROUTES } from '@routes/app-routes.constants';
import { createRoleGuard } from './role.guard';

export const amsGuard = createRoleGuard((auth) => auth.canAccessAms$, {
  denyPath: APP_ROUTES.accessDenied,
  timeoutPath: APP_ROUTES.home,
});
